import { combineReducers } from 'redux';
import { authReducer } from './authentication/reducers';
import {
    aboutInfoDataReducers,
    aboutInfoPPTListDataReducers,
    aboutInfoPPTDetailsDataReducers,
    submitAboutPPTInfoDataReducers,
    getExchangeDataReducers,
    submitAboutMissingPPTInfoDataReducers,
    postStartTokenDataReducers,
    postExchnagePricenDataReducers,
} from './about/reducers';
import {
    exchangeModelDetailReducer,
    getBrandReducers,
    getModelReducers,
    productTypeReducers,
} from './common/reducers';
import { fileUploadReducer } from './exchange/reducers';

const rootReducers = combineReducers({
    auth: authReducer,
    aboutInfoData: aboutInfoDataReducers,
    aboutInfoPPTListData: aboutInfoPPTListDataReducers,
    aboutInfoPPTDetailsData: aboutInfoPPTDetailsDataReducers,
    submitAboutPPTInfoData: submitAboutPPTInfoDataReducers,
    getExchangeData: getExchangeDataReducers,
    submitAboutMissingPPTInfoData: submitAboutMissingPPTInfoDataReducers,
    postStartTokenData: postStartTokenDataReducers,
    postExchnagePriceData: postExchnagePricenDataReducers,
    productType: productTypeReducers,
    getBrand: getBrandReducers,
    getModel: getModelReducers,
    exchangeModelDetail: exchangeModelDetailReducer,
    fileUpload: fileUploadReducer,
});

export default rootReducers;
